import React from "react";
import { Editor } from "@tinymce/tinymce-react";

const ContentEditor = ({ value, onChange }) => {
    return (
        <Editor
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            value={value}
            onEditorChange={onChange}
            init={{
                license_key: "gpl",

                plugins:
                    "advlist autolink lists link image charmap preview anchor " +
                    "searchreplace visualblocks code fullscreen insertdatetime media " +
                    "table help wordcount",

                toolbar1:
                    "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | " +
                    "bullist numlist outdent indent | mediaButton | link image | removeformat | code preview",

                toolbar2:
                    "insertdatetime | ctaButton insertStars | help | table | hr visualblocks fullscreen | " +
                    "styles | strikethrough underline | KBDButton",

                height: 800,
                toolbar_sticky: true,
                toolbar_sticky_offset: 70,

                relative_urls: false,
                remove_script_host: false,
                convert_urls: true,

                branding: false,
                promotion: false,

                content_style:
                    "body { font-family: Helvetica, Arial, sans-serif; font-size: 16px; }",

                setup: (editor) => {
                    editor.ui.registry.addButton("KBDButton", {
                        text: "KBD",
                        onAction: () => {
                            editor.insertContent("<kbd>Shortcut</kbd>");
                        },
                    });

                    editor.ui.registry.addButton("insertStars", {
                        text: "★★★★★",
                        onAction: () => {
                            editor.insertContent("★★★★★");
                        },
                    });

                    editor.ui.registry.addButton("ctaButton", {
                        text: "CTA",
                        onAction: () => {
                            editor.insertContent(
                                '<a href="#" class="btn btn-primary">Call to Action</a>'
                            );
                        },
                    });

                    editor.ui.registry.addButton("mediaButton", {
                        text: "Media",
                        onAction: () => {
                            editor.execCommand("mceMedia");
                        },
                    });
                },
            }}
        />
    );
};

export default ContentEditor;